(function ($, Drupal) {
  Drupal.initBannerVideoSize = function (element, width, height) {
    $(element).each(function () {
      $(this).data('height', height);
      $(this).data('width', width);
    });

    Drupal.scaleBannerVideoSize(element);
  }
  Drupal.scaleBannerVideoSize = function (element) {
    var videoWidth, videoHeight;

    $(element).each(function () {
      var videoAspectRatio = $(this).data('height') / $(this).data('width');
      var windowHeight = $(this).parents('.video-container').outerHeight() + 5;
      var windowWidth = $(this).parents('.video-container').outerWidth() + 100;

      videoWidth = windowWidth;
      videoHeight = videoWidth * videoAspectRatio;

      if (videoHeight < windowHeight) {
        videoHeight = windowHeight;
        videoWidth = videoHeight / videoAspectRatio;
      }

      $paragraph = $(this).width(videoWidth).height(videoHeight).parents('.paragraph');
      if ($paragraph.hasClass('has-video')) {
        $paragraph.removeClass('no-background');
      }

      $('.hero-title .video-container video').addClass('fadeIn animated');

    });
  }
  Drupal.initBannerVideoFade = function(element) {
    if ($(element).data('loops') !== 1) {
      window.setTimeout(function() {
        $(element).addClass('fade');
      }, $(element).data('loop-length') * 1000);
    }
  }

  /**
   * Control hero title video size on resize.
   */
  Drupal.behaviors.kinaxisHeroTitle = {
    attach: function (context, settings) {
      $(once('kinaxisHeroTitle','.hero-title' )).each(function () {  
        $(window).on('resize', function () {
          var windowWidth = $(window).width() + 100
          if (typeof Drupal.kinaxisWindowWidth !== 'undefined' && Drupal.kinaxisWindowWidth == windowWidth) {
            return;
          }
          Drupal.kinaxisWindowWidth = windowWidth;

          Drupal.scaleBannerVideoSize('.video-container .poster img');
          Drupal.scaleBannerVideoSize('.video-container video');
          Drupal.scaleBannerVideoSize('.vidyard-player-container iframe');
        });

        var $paragraph = $(this).parent();
        Drupal.initBannerVideoSize('.vidyard-player-container iframe', '.video-container .poster img', $('.video-container .poster img').attr('data-width'), $('.video-container .poster img').attr('data-height'));

        // Lazy load the videos. At this point the
        // document readyState should be "interactive"
        $('.video-container video.lazy').each(function() {
          $(this).find('source').each(function() {
            if ($(this).attr('data-src')) {
              $(this).attr('src', $(this).attr('data-src'));
            }
          });
          this.load();
        });

        // initialize the video only after metadata is available
        if ($('.video-container video').length) {
          if ($('.video-container video').get(0).readyState >= $('.video-container video').get(0).HAVE_ENOUGH_DATA) {
            Drupal.initBannerVideoSize('.video-container video', parseInt($('.video-container video').get(0).videoWidth), parseInt($('.video-container video').get(0).videoHeight));
            Drupal.initBannerVideoFade('.video-container video');
          } else {
            $(window).trigger('resize');
            $('.video-container video').on('canplay', function (e) {
              Drupal.initBannerVideoSize('.video-container video', parseInt($('.video-container video').get(0).videoWidth), parseInt($('.video-container video').get(0).videoHeight));
              Drupal.initBannerVideoFade('.video-container video');
            });
          }
        }

        // Initialize vidyard video once loaded
        var players = $(this).find('.video-clipper [data-uuid]');
        if (players.length) {
          var uuid = players.first().attr('data-uuid');
          window.onVidyardAPI = (vidyardEmbed) => {
            vidyardEmbed.api.addReadyListener((_, player) => {
              player.play();
              player.setVolume(0);
              var $paragraph = $('[data-uuid="' + player.uuid + '"]').parents('.paragraph').first();
              $paragraph.removeClass('no-background');
              Drupal.initBannerVideoFade($paragraph.find('.video-clipper').get(0));
           }, uuid);
          }
        }
      });
    }
  }
})(jQuery, Drupal);